import { gql } from '@apollo/client';

const UPDATE_SUMMARY_REPORT_MUTATION = gql`
  mutation updateSummaryReport($input: SummaryReportDataInput) {
    updateSummaryReport(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_SUMMARY_REPORT_MUTATION;
